import React from 'react';
import { Button } from '@block/plug';
import './index.scss';

// 倒计时组件
interface Props {
  setTime: () => void;
}
interface State {
  secondsElapsed: number;
}
class CountDown extends React.Component<Props, State> {
  interval: any;

  getCodes: (event: MouseEvent, button: any) => void;

  codesRef: any;

  constructor(props) {
    super(props);
    this.state = { secondsElapsed: 60 };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const { secondsElapsed } = this.state;
      if (secondsElapsed > 1) {
        this.tick();
      } else {
        const { setTime } = this.props;
        setTime();
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  tick = () => {
    this.setState((prevState) => ({
      secondsElapsed: prevState.secondsElapsed - 1,
    }));
  };

  render() {
    const { secondsElapsed } = this.state;
    return (
      <div className="countdown-btn">
        <Button
          ref={(target) => {
            this.codesRef = target;
          }}
          size="large"
          type="primary"
          onClick={this.getCodes}
          disabled
        >
          {secondsElapsed}
          s后重试
        </Button>
      </div>
    );
  }
}
export default CountDown;
